import { useState, useEffect, useMemo, useCallback } from 'react'
import { API, API_ROUTER } from '../../../api'
import { toast } from 'react-toastify'

export const useUserParticipation = (tournament, userData, requestSuccess) => {
  const [isUserDataParicipant, setIsUserDataParicipant] = useState()
  const [userGames, setUserGames] = useState()
  const [errorMessage, setErrorMessage] = useState('')

  const hasUserGame = useMemo(() => {
    if (!userGames || !tournament?.game?.id) return false
    const games = userGames.map(i => i.game.id)
    return games.includes(tournament?.game?.id)
  }, [userGames, tournament?.game?.id])

  const isUserRegistered = useMemo(
    () =>
      isUserDataParicipant?.team ||
      isUserDataParicipant?.teamRoster ||
      isUserDataParicipant?.user,
    [isUserDataParicipant]
  )

  const canRegister = useMemo(
    () =>
      tournament?.status === 'registration' &&
      !isUserRegistered &&
      requestSuccess,
    [tournament?.status, isUserRegistered, requestSuccess]
  )

  const shouldShowAddGameButton = useMemo(
    () => canRegister && !hasUserGame,
    [canRegister, hasUserGame]
  )

  const shouldShowRegistrationButton = useMemo(
    () => canRegister && hasUserGame && userData?.profileInfoFilled,
    [canRegister, hasUserGame, userData?.profileInfoFilled]
  )

  const shouldShowFillProfileButton = useMemo(
    () => canRegister && hasUserGame && !userData?.profileInfoFilled,
    [canRegister, hasUserGame, userData?.profileInfoFilled]
  )

  const getUserGames = useCallback(() => {
    API.request({
      ...API_ROUTER.games.getUserGames,
    })
      .then(res => {
        setUserGames(res.games)
      })
      .catch(err => console.log(err))
  }, [])

  const submitTeamRoster = useCallback(() => {
    API.request({
      ...API_ROUTER.tournaments.postTeamRoster,
      pathKeys: {
        tournamentId: tournament?.id,
      },
      data: {
        user: {
          id: userData?.id,
          nickname: userData?.nickname,
        },
        team: null,
      },
    })
      .then(() => {
        toast.success('Your registration successfully')
      })
      .catch(err => err?.data?.message && toast.error(err?.data?.message))
  }, [tournament?.id, userData?.id, userData?.nickname])

  const getUserCurrentTournament = useCallback(() => {
    API.request({
      ...API_ROUTER.tournaments.getUserCurrentTournament,
      pathKeys: {
        userId: userData?.id,
        tournamentId: tournament?.id,
      },
    })
      .then(res => {
        setIsUserDataParicipant(res)
      })
      .catch(err => console.log(err))
  }, [userData?.id, tournament?.id])

  const checkParticipationTypeData = useCallback(
    (type, fn) => {
      type === 'user'
        ? submitTeamRoster()
        : fn(`/battleCup/${tournament?.id}/registrationTournament`)
    },
    [submitTeamRoster, tournament?.id]
  )

  useEffect(() => {
    getUserGames()
  }, [getUserGames])

  useEffect(() => {
    if (userData?.id && tournament?.id) {
      getUserCurrentTournament()
    }
  }, [userData?.id, tournament?.id, getUserCurrentTournament])

  return {
    isUserDataParicipant,
    userGames,
    errorMessage,
    setErrorMessage,
    hasUserGame,
    isUserRegistered,
    canRegister,
    shouldShowAddGameButton,
    shouldShowRegistrationButton,
    shouldShowFillProfileButton,
    getUserGames,
    submitTeamRoster,
    getUserCurrentTournament,
    checkParticipationTypeData,
  }
}
